import { getOptionalAddonsForPlanId, getRequiredAddonsForPlanId } from './addons';
import { projectLocationAddonMapper, USReforestationProject } from '../tree-projects';
import { Country, locationNames, Location } from './countries';
import * as addons from './addons';
import * as plans from './plans';
import { currencySymbols, locationCurrencyCodeMapper } from './currencies';
import { transformLocationIntoValidPlanCountryCode } from './country-transform';
import { basicPlanIds } from './plan-country-mappings';

export enum Consumptions {
  HIGH = 'high',
  VERY_HIGH = 'very high',
}

export const plansForLocations: {
  [country in Country]: plans.Plans;
} = {
  AU: plans.individualPlansAU,
  CA: plans.individualPlansCA,
  EU: plans.individualPlansEU,
  GB: plans.individualPlansGB,
  US: plans.individualPlansUS,
  AD: plans.individualPlansUSDMedium, // Andorra
  AF: plans.individualPlansUSDMedium, // Afghanistan
  AG: plans.individualPlansUSDMedium, // Antigua & Barbuda
  AL: plans.individualPlansUSDMedium, // Albania
  AM: plans.individualPlansUSDMedium, // Armenia
  AO: plans.individualPlansUSDMedium, // Angola
  AQ: plans.individualPlansUSDMedium, // Antarctica
  AR: plans.individualPlansUSDMedium, // Argentina
  AW: plans.individualPlansUSDMedium, // Aruba
  AZ: plans.individualPlansUSDMedium, // Azerbaijan
  BA: plans.individualPlansUSDMedium, // Bosnia & Herzegovina
  BB: plans.individualPlansUSDMedium, // Barbados
  BD: plans.individualPlansUSDMedium, // Bangladesh
  BF: plans.individualPlansUSDMedium, // Burkina Faso
  BI: plans.individualPlansUSDMedium, // Burundi
  BJ: plans.individualPlansUSDMedium, // Benin
  BM: plans.individualPlansUSDMedium, // Bermuda
  BO: plans.individualPlansUSDMedium, // Bolivia
  BQ: plans.individualPlansUSDMedium, // Caribbean Netherlands
  BR: plans.individualPlansUSDMedium, // Brazil
  BS: plans.individualPlansUSDMedium, // Bahamas
  BT: plans.individualPlansUSDMedium, // Bhutan
  BY: plans.individualPlansUSDMedium, // Belarus
  CD: plans.individualPlansUSDMedium, // Congo - Kinshasa
  CI: plans.individualPlansUSDMedium, // Côte d’Ivoire
  CL: plans.individualPlansUSDMedium, // Chile
  CM: plans.individualPlansUSDMedium, // Cameroon
  CN: plans.individualPlansUSDMedium, // China
  CO: plans.individualPlansUSDMedium, // Colombia
  CR: plans.individualPlansUSDMedium, // Costa Rica
  CU: plans.individualPlansUSDMedium, // Cuba
  CV: plans.individualPlansUSDMedium, // Cape Verde
  CW: plans.individualPlansUSDMedium, // Curaçao
  DO: plans.individualPlansUSDMedium, // Dominican Republic
  DZ: plans.individualPlansUSDMedium, // Algeria
  EC: plans.individualPlansUSDMedium, // Ecuador
  EG: plans.individualPlansUSDMedium, // Egypt
  EH: plans.individualPlansUSDMedium, // Western Sahara
  ET: plans.individualPlansUSDMedium, // Ethiopia
  FJ: plans.individualPlansUSDMedium, // Fiji
  FK: plans.individualPlansUSDMedium, // Falkland Islands (Islas Malvinas)
  FM: plans.individualPlansUSDMedium, // Micronesia
  FO: plans.individualPlansUSDMedium, // Faroe Islands
  GA: plans.individualPlansUSDMedium, // Gabon
  GD: plans.individualPlansUSDMedium, // Grenada
  GE: plans.individualPlansUSDMedium, // Georgia
  GG: plans.individualPlansUSDMedium, // Guernsey
  GH: plans.individualPlansUSDMedium, // Ghana
  GI: plans.individualPlansUSDMedium, // Gibraltar
  GM: plans.individualPlansUSDMedium, // Gambia
  GP: plans.individualPlansUSDMedium, // Guadeloupe
  GQ: plans.individualPlansUSDMedium, // Equatorial Guinea
  GR: plans.individualPlansUSDMedium, // Greece
  GT: plans.individualPlansUSDMedium, // Guatemala
  GU: plans.individualPlansUSDMedium, // Guam
  HK: plans.individualPlansUSDMedium, // Hong Kong
  HN: plans.individualPlansUSDMedium, // Honduras
  HR: plans.individualPlansUSDMedium, // Croatia
  HT: plans.individualPlansUSDMedium, // Haiti
  ID: plans.individualPlansUSDMedium, // Indonesia
  IL: plans.individualPlansUSDMedium, // Israel
  IN: plans.individualPlansUSDMedium, // India
  IQ: plans.individualPlansUSDMedium, // Iraq
  IR: plans.individualPlansUSDMedium, // Iran
  IS: plans.individualPlansUSDMedium, // Iceland
  JE: plans.individualPlansUSDMedium, // Jersey
  JM: plans.individualPlansUSDMedium, // Jamaica
  JO: plans.individualPlansUSDMedium, // Jordan
  JP: plans.individualPlansUSDMedium, // Japan
  KE: plans.individualPlansUSDMedium, // Kenya
  KG: plans.individualPlansUSDMedium, // Kyrgyzstan
  KH: plans.individualPlansUSDMedium, // Cambodia
  KN: plans.individualPlansUSDMedium, // St. Kitts & Nevis
  KR: plans.individualPlansUSDMedium, // South Korea
  KY: plans.individualPlansUSDMedium, // Cayman Islands
  LA: plans.individualPlansUSDMedium, // Laos
  LB: plans.individualPlansUSDMedium, // Lebanon
  LC: plans.individualPlansUSDMedium, // St. Lucia
  LI: plans.individualPlansUSDMedium, // Liechtenstein
  LK: plans.individualPlansUSDMedium, // Sri Lanka
  LS: plans.individualPlansUSDMedium, // Lesotho
  LT: plans.individualPlansUSDMedium, // Lithuania
  LV: plans.individualPlansUSDMedium, // Latvia
  LY: plans.individualPlansUSDMedium, // Libya
  MA: plans.individualPlansUSDMedium, // Morocco
  MC: plans.individualPlansUSDMedium, // Monaco
  MD: plans.individualPlansUSDMedium, // Moldova
  ME: plans.individualPlansUSDMedium, // Montenegro
  MG: plans.individualPlansUSDMedium, // Madagascar
  MK: plans.individualPlansUSDMedium, // North Macedonia
  ML: plans.individualPlansUSDMedium, // Mali
  MM: plans.individualPlansUSDMedium, // Myanmar (Burma)
  MN: plans.individualPlansUSDMedium, // Mongolia
  MO: plans.individualPlansUSDMedium, // Macao
  MQ: plans.individualPlansUSDMedium, // Martinique
  MR: plans.individualPlansUSDMedium, // Mauritania
  MT: plans.individualPlansUSDMedium, // Malta
  MU: plans.individualPlansUSDMedium, // Mauritius
  MV: plans.individualPlansUSDMedium, // Maldives
  MW: plans.individualPlansUSDMedium, // Malawi
  MX: plans.individualPlansUSDMedium, // Mexico
  MY: plans.individualPlansUSDMedium, // Malaysia
  MZ: plans.individualPlansUSDMedium, // Mozambique
  NA: plans.individualPlansUSDMedium, // Namibia
  NC: plans.individualPlansUSDMedium, // New Caledonia
  NE: plans.individualPlansUSDMedium, // Niger
  NF: plans.individualPlansUSDMedium, // Norfolk Island
  NG: plans.individualPlansUSDMedium, // Nigeria
  NI: plans.individualPlansUSDMedium, // Nicaragua
  NP: plans.individualPlansUSDMedium, // Nepal
  NZ: plans.individualPlansUSDMedium, // New Zealand
  PA: plans.individualPlansUSDMedium, // Panama
  PE: plans.individualPlansUSDMedium, // Peru
  PF: plans.individualPlansUSDMedium, // French Polynesia
  PG: plans.individualPlansUSDMedium, // Papua New Guinea
  PH: plans.individualPlansUSDMedium, // Philippines
  PK: plans.individualPlansUSDMedium, // Pakistan
  PR: plans.individualPlansUSDMedium, // Puerto Rico
  PS: plans.individualPlansUSDMedium, // Palestine
  PY: plans.individualPlansUSDMedium, // Paraguay
  RE: plans.individualPlansUSDMedium, // Réunion
  RS: plans.individualPlansUSDMedium, // Serbia
  RU: plans.individualPlansUSDMedium, // Russia
  RW: plans.individualPlansUSDMedium, // Rwanda
  SC: plans.individualPlansUSDMedium, // Seychelles
  SD: plans.individualPlansUSDMedium, // Sudan
  SG: plans.individualPlansUSDMedium, // Singapore
  SI: plans.individualPlansUSDMedium, // Slovenia
  SK: plans.individualPlansUSDMedium, // Slovakia
  SL: plans.individualPlansUSDMedium, // Sierra Leone
  SM: plans.individualPlansUSDMedium, // San Marino
  SN: plans.individualPlansUSDMedium, // Senegal
  SO: plans.individualPlansUSDMedium, // Somalia
  SS: plans.individualPlansUSDMedium, // South Sudan
  SV: plans.individualPlansUSDMedium, // El Salvador
  SY: plans.individualPlansUSDMedium, // Syria
  SZ: plans.individualPlansUSDMedium, // Eswatini
  TD: plans.individualPlansUSDMedium, // Chad
  TG: plans.individualPlansUSDMedium, // Togo
  TH: plans.individualPlansUSDMedium, // Thailand
  TJ: plans.individualPlansUSDMedium, // Tajikistan
  TL: plans.individualPlansUSDMedium, // Timor-Leste
  TN: plans.individualPlansUSDMedium, // Tunisia
  TR: plans.individualPlansUSDMedium, // Turkey
  TV: plans.individualPlansUSDMedium, // Tuvalu
  TW: plans.individualPlansUSDMedium, // Taiwan
  TZ: plans.individualPlansUSDMedium, // Tanzania
  UA: plans.individualPlansUSDMedium, // Ukraine
  UG: plans.individualPlansUSDMedium, // Uganda
  UY: plans.individualPlansUSDMedium, // Uruguay
  UZ: plans.individualPlansUSDMedium, // Uzbekistan
  VC: plans.individualPlansUSDMedium, // St. Vincent & Grenadines
  VE: plans.individualPlansUSDMedium, // Venezuela
  VG: plans.individualPlansUSDMedium, // British Virgin Islands
  VI: plans.individualPlansUSDMedium, // U.S. Virgin Islands
  VN: plans.individualPlansUSDMedium, // Vietnam
  VU: plans.individualPlansUSDMedium, // Vanuatu
  XK: plans.individualPlansUSDMedium, // Kosovo
  YE: plans.individualPlansUSDMedium, // Yemen
  YT: plans.individualPlansUSDMedium, // Mayotte
  ZA: plans.individualPlansUSDMedium, // South Africa
  ZM: plans.individualPlansUSDMedium, // Zambia
  ZW: plans.individualPlansUSDMedium, // Zimbabwe
  AE: plans.individualPlansUS, // United Arab Emirates
  BH: plans.individualPlansUS, // Bahrain
  BN: plans.individualPlansUS, // Brunei
  BW: plans.individualPlansUS, // Botswana
  BZ: plans.individualPlansUS, // Belize
  EE: plans.individualPlansUS, // Estonia
  GY: plans.individualPlansUS, // Guyana
  KW: plans.individualPlansUS, // Kuwait
  KZ: plans.individualPlansUS, // Kazakhstan
  LU: plans.individualPlansUS, // Luxembourg
  OM: plans.individualPlansUS, // Oman
  QA: plans.individualPlansUS, // Qatar
  SA: plans.individualPlansUS, // Saudi Arabia
  SR: plans.individualPlansUS, // Suriname
  TM: plans.individualPlansUS, // Turkmenistan
  TT: plans.individualPlansUS, // Trinidad & Tobago
  AT: plans.individualPlansEU, // Austria
  BE: plans.individualPlansEU, // Belgium
  CY: plans.individualPlansEU, // Cyprus
  DK: plans.individualPlansEU, // Denmark
  FI: plans.individualPlansEU, // Finland
  FR: plans.individualPlansEU, // France
  DE: plans.individualPlansEU, // Germany
  IE: plans.individualPlansEU, // Ireland
  IT: plans.individualPlansEU, // Italy
  NL: plans.individualPlansEU, // Netherlands
  NO: plans.individualPlansEU, // Norway
  PL: plans.individualPlansEU, // Poland
  ES: plans.individualPlansEU, // Spain
  SE: plans.individualPlansEU, // Sweden
  CH: plans.individualPlansEU, // Switzerland
  CZ: plans.individualPlansEU, // Czech Republic
  HU: plans.individualPlansEU, // Hungary
  PT: plans.individualPlansEU, // Portugal
  BG: plans.individualPlansEU, // Bulgaria
  RO: plans.individualPlansEU, // Romania
};

const familyPlanIdsForLocation = {
  AU: plans.familyPlanIdAU,
  CA: plans.familyPlanIdCA,
  EU: plans.familyPlanIdEU,
  GB: plans.familyPlanIdGB,
  US: plans.familyPlanIdUS,
  AD: plans.familyPlanIdUSMedium,
  AF: plans.familyPlanIdUSMedium,
  AG: plans.familyPlanIdUSMedium,
  AL: plans.familyPlanIdUSMedium,
  AM: plans.familyPlanIdUSMedium,
  AO: plans.familyPlanIdUSMedium,
  AQ: plans.familyPlanIdUSMedium,
  AR: plans.familyPlanIdUSMedium,
  AW: plans.familyPlanIdUSMedium,
  AZ: plans.familyPlanIdUSMedium,
  BA: plans.familyPlanIdUSMedium,
  BB: plans.familyPlanIdUSMedium,
  BD: plans.familyPlanIdUSMedium,
  BF: plans.familyPlanIdUSMedium,
  BI: plans.familyPlanIdUSMedium,
  BJ: plans.familyPlanIdUSMedium,
  BM: plans.familyPlanIdUSMedium,
  BO: plans.familyPlanIdUSMedium,
  BQ: plans.familyPlanIdUSMedium,
  BR: plans.familyPlanIdUSMedium,
  BS: plans.familyPlanIdUSMedium,
  BT: plans.familyPlanIdUSMedium,
  BY: plans.familyPlanIdUSMedium,
  CD: plans.familyPlanIdUSMedium,
  CI: plans.familyPlanIdUSMedium,
  CL: plans.familyPlanIdUSMedium,
  CM: plans.familyPlanIdUSMedium,
  CN: plans.familyPlanIdUSMedium,
  CO: plans.familyPlanIdUSMedium,
  CR: plans.familyPlanIdUSMedium,
  CU: plans.familyPlanIdUSMedium,
  CV: plans.familyPlanIdUSMedium,
  CW: plans.familyPlanIdUSMedium,
  DO: plans.familyPlanIdUSMedium,
  DZ: plans.familyPlanIdUSMedium,
  EC: plans.familyPlanIdUSMedium,
  EG: plans.familyPlanIdUSMedium,
  EH: plans.familyPlanIdUSMedium,
  ET: plans.familyPlanIdUSMedium,
  FJ: plans.familyPlanIdUSMedium,
  FK: plans.familyPlanIdUSMedium,
  FM: plans.familyPlanIdUSMedium,
  FO: plans.familyPlanIdUSMedium,
  GA: plans.familyPlanIdUSMedium,
  GD: plans.familyPlanIdUSMedium,
  GE: plans.familyPlanIdUSMedium,
  GG: plans.familyPlanIdUSMedium,
  GH: plans.familyPlanIdUSMedium,
  GI: plans.familyPlanIdUSMedium,
  GM: plans.familyPlanIdUSMedium,
  GP: plans.familyPlanIdUSMedium,
  GQ: plans.familyPlanIdUSMedium,
  GR: plans.familyPlanIdUSMedium,
  GT: plans.familyPlanIdUSMedium,
  GU: plans.familyPlanIdUSMedium,
  HK: plans.familyPlanIdUSMedium,
  HN: plans.familyPlanIdUSMedium,
  HR: plans.familyPlanIdUSMedium,
  HT: plans.familyPlanIdUSMedium,
  ID: plans.familyPlanIdUSMedium,
  IL: plans.familyPlanIdUSMedium,
  IN: plans.familyPlanIdUSMedium,
  IQ: plans.familyPlanIdUSMedium,
  IR: plans.familyPlanIdUSMedium,
  IS: plans.familyPlanIdUSMedium,
  JE: plans.familyPlanIdUSMedium,
  JM: plans.familyPlanIdUSMedium,
  JO: plans.familyPlanIdUSMedium,
  JP: plans.familyPlanIdUSMedium,
  KE: plans.familyPlanIdUSMedium,
  KG: plans.familyPlanIdUSMedium,
  KH: plans.familyPlanIdUSMedium,
  KN: plans.familyPlanIdUSMedium,
  KR: plans.familyPlanIdUSMedium,
  KY: plans.familyPlanIdUSMedium,
  LA: plans.familyPlanIdUSMedium,
  LB: plans.familyPlanIdUSMedium,
  LC: plans.familyPlanIdUSMedium,
  LI: plans.familyPlanIdUSMedium,
  LK: plans.familyPlanIdUSMedium,
  LS: plans.familyPlanIdUSMedium,
  LT: plans.familyPlanIdUSMedium,
  LV: plans.familyPlanIdUSMedium,
  LY: plans.familyPlanIdUSMedium,
  MA: plans.familyPlanIdUSMedium,
  MC: plans.familyPlanIdUSMedium,
  MD: plans.familyPlanIdUSMedium,
  ME: plans.familyPlanIdUSMedium,
  MG: plans.familyPlanIdUSMedium,
  MK: plans.familyPlanIdUSMedium,
  ML: plans.familyPlanIdUSMedium,
  MM: plans.familyPlanIdUSMedium,
  MN: plans.familyPlanIdUSMedium,
  MO: plans.familyPlanIdUSMedium,
  MQ: plans.familyPlanIdUSMedium,
  MR: plans.familyPlanIdUSMedium,
  MT: plans.familyPlanIdUSMedium,
  MU: plans.familyPlanIdUSMedium,
  MV: plans.familyPlanIdUSMedium,
  MW: plans.familyPlanIdUSMedium,
  MX: plans.familyPlanIdUSMedium,
  MY: plans.familyPlanIdUSMedium,
  MZ: plans.familyPlanIdUSMedium,
  NA: plans.familyPlanIdUSMedium,
  NC: plans.familyPlanIdUSMedium,
  NE: plans.familyPlanIdUSMedium,
  NF: plans.familyPlanIdUSMedium,
  NG: plans.familyPlanIdUSMedium,
  NI: plans.familyPlanIdUSMedium,
  NP: plans.familyPlanIdUSMedium,
  NZ: plans.familyPlanIdUSMedium,
  PA: plans.familyPlanIdUSMedium,
  PE: plans.familyPlanIdUSMedium,
  PF: plans.familyPlanIdUSMedium,
  PG: plans.familyPlanIdUSMedium,
  PH: plans.familyPlanIdUSMedium,
  PK: plans.familyPlanIdUSMedium,
  PR: plans.familyPlanIdUSMedium,
  PS: plans.familyPlanIdUSMedium,
  PY: plans.familyPlanIdUSMedium,
  RE: plans.familyPlanIdUSMedium,
  RS: plans.familyPlanIdUSMedium,
  RU: plans.familyPlanIdUSMedium,
  RW: plans.familyPlanIdUSMedium,
  SC: plans.familyPlanIdUSMedium,
  SD: plans.familyPlanIdUSMedium,
  SG: plans.familyPlanIdUSMedium,
  SI: plans.familyPlanIdUSMedium,
  SK: plans.familyPlanIdUSMedium,
  SL: plans.familyPlanIdUSMedium,
  SM: plans.familyPlanIdUSMedium,
  SN: plans.familyPlanIdUSMedium,
  SO: plans.familyPlanIdUSMedium,
  SS: plans.familyPlanIdUSMedium,
  SV: plans.familyPlanIdUSMedium,
  SY: plans.familyPlanIdUSMedium,
  SZ: plans.familyPlanIdUSMedium,
  TD: plans.familyPlanIdUSMedium,
  TG: plans.familyPlanIdUSMedium,
  TH: plans.familyPlanIdUSMedium,
  TJ: plans.familyPlanIdUSMedium,
  TL: plans.familyPlanIdUSMedium,
  TN: plans.familyPlanIdUSMedium,
  TR: plans.familyPlanIdUSMedium,
  TV: plans.familyPlanIdUSMedium,
  TW: plans.familyPlanIdUSMedium,
  TZ: plans.familyPlanIdUSMedium,
  UA: plans.familyPlanIdUSMedium,
  UG: plans.familyPlanIdUSMedium,
  UY: plans.familyPlanIdUSMedium,
  UZ: plans.familyPlanIdUSMedium,
  VC: plans.familyPlanIdUSMedium,
  VE: plans.familyPlanIdUSMedium,
  VG: plans.familyPlanIdUSMedium,
  VI: plans.familyPlanIdUSMedium,
  VN: plans.familyPlanIdUSMedium,
  VU: plans.familyPlanIdUSMedium,
  XK: plans.familyPlanIdUSMedium,
  YE: plans.familyPlanIdUSMedium,
  YT: plans.familyPlanIdUSMedium,
  ZA: plans.familyPlanIdUSMedium,
  ZM: plans.familyPlanIdUSMedium,
  ZW: plans.familyPlanIdUSMedium,
  AE: plans.familyPlanIdUS,
  BH: plans.familyPlanIdUS,
  BN: plans.familyPlanIdUS,
  BW: plans.familyPlanIdUS,
  BZ: plans.familyPlanIdUS,
  EE: plans.familyPlanIdUS,
  GY: plans.familyPlanIdUS,
  KW: plans.familyPlanIdUS,
  KZ: plans.familyPlanIdUS,
  LU: plans.familyPlanIdUS,
  OM: plans.familyPlanIdUS,
  QA: plans.familyPlanIdUS,
  SA: plans.familyPlanIdUS,
  SR: plans.familyPlanIdUS,
  TM: plans.familyPlanIdUS,
  TT: plans.familyPlanIdUS,
  AT: plans.familyPlanIdEU,
  BE: plans.familyPlanIdEU,
  CY: plans.familyPlanIdEU,
  DK: plans.familyPlanIdEU,
  FI: plans.familyPlanIdEU,
  FR: plans.familyPlanIdEU,
  DE: plans.familyPlanIdEU,
  IT: plans.familyPlanIdEU,
  IE: plans.familyPlanIdEU,
  NL: plans.familyPlanIdEU,
  NO: plans.familyPlanIdEU,
  PL: plans.familyPlanIdEU,
  ES: plans.familyPlanIdEU,
  SE: plans.familyPlanIdEU,
  CH: plans.familyPlanIdEU,
  CZ: plans.familyPlanIdEU,
  HU: plans.familyPlanIdEU,
  PT: plans.familyPlanIdEU,
  BG: plans.familyPlanIdEU,
  RO: plans.familyPlanIdEU,
} as {
  [country in Country]: string;
};

const familyAddonsForLocations = {
  AU: addons.familyAddonsAU,
  CA: addons.familyAddonsCA,
  EU: addons.familyAddonsEU,
  GB: addons.familyAddonsGB,
  US: addons.familyAddonsUS,
  AD: addons.familyAddonsUSDMedium,
  AF: addons.familyAddonsUSDMedium,
  AG: addons.familyAddonsUSDMedium,
  AL: addons.familyAddonsUSDMedium,
  AM: addons.familyAddonsUSDMedium,
  AO: addons.familyAddonsUSDMedium,
  AQ: addons.familyAddonsUSDMedium,
  AR: addons.familyAddonsUSDMedium,
  AW: addons.familyAddonsUSDMedium,
  AZ: addons.familyAddonsUSDMedium,
  BA: addons.familyAddonsUSDMedium,
  BB: addons.familyAddonsUSDMedium,
  BD: addons.familyAddonsUSDMedium,
  BF: addons.familyAddonsUSDMedium,
  BI: addons.familyAddonsUSDMedium,
  BJ: addons.familyAddonsUSDMedium,
  BM: addons.familyAddonsUSDMedium,
  BO: addons.familyAddonsUSDMedium,
  BQ: addons.familyAddonsUSDMedium,
  BR: addons.familyAddonsUSDMedium,
  BS: addons.familyAddonsUSDMedium,
  BT: addons.familyAddonsUSDMedium,
  BY: addons.familyAddonsUSDMedium,
  CD: addons.familyAddonsUSDMedium,
  CI: addons.familyAddonsUSDMedium,
  CL: addons.familyAddonsUSDMedium,
  CM: addons.familyAddonsUSDMedium,
  CN: addons.familyAddonsUSDMedium,
  CO: addons.familyAddonsUSDMedium,
  CR: addons.familyAddonsUSDMedium,
  CU: addons.familyAddonsUSDMedium,
  CV: addons.familyAddonsUSDMedium,
  CW: addons.familyAddonsUSDMedium,
  DO: addons.familyAddonsUSDMedium,
  DZ: addons.familyAddonsUSDMedium,
  EC: addons.familyAddonsUSDMedium,
  EG: addons.familyAddonsUSDMedium,
  EH: addons.familyAddonsUSDMedium,
  ET: addons.familyAddonsUSDMedium,
  FJ: addons.familyAddonsUSDMedium,
  FK: addons.familyAddonsUSDMedium,
  FM: addons.familyAddonsUSDMedium,
  FO: addons.familyAddonsUSDMedium,
  GA: addons.familyAddonsUSDMedium,
  GD: addons.familyAddonsUSDMedium,
  GE: addons.familyAddonsUSDMedium,
  GG: addons.familyAddonsUSDMedium,
  GH: addons.familyAddonsUSDMedium,
  GI: addons.familyAddonsUSDMedium,
  GM: addons.familyAddonsUSDMedium,
  GP: addons.familyAddonsUSDMedium,
  GQ: addons.familyAddonsUSDMedium,
  GR: addons.familyAddonsUSDMedium,
  GT: addons.familyAddonsUSDMedium,
  GU: addons.familyAddonsUSDMedium,
  HK: addons.familyAddonsUSDMedium,
  HN: addons.familyAddonsUSDMedium,
  HR: addons.familyAddonsUSDMedium,
  HT: addons.familyAddonsUSDMedium,
  ID: addons.familyAddonsUSDMedium,
  IL: addons.familyAddonsUSDMedium,
  IN: addons.familyAddonsUSDMedium,
  IQ: addons.familyAddonsUSDMedium,
  IR: addons.familyAddonsUSDMedium,
  IS: addons.familyAddonsUSDMedium,
  JE: addons.familyAddonsUSDMedium,
  JM: addons.familyAddonsUSDMedium,
  JO: addons.familyAddonsUSDMedium,
  JP: addons.familyAddonsUSDMedium,
  KE: addons.familyAddonsUSDMedium,
  KG: addons.familyAddonsUSDMedium,
  KH: addons.familyAddonsUSDMedium,
  KN: addons.familyAddonsUSDMedium,
  KR: addons.familyAddonsUSDMedium,
  KY: addons.familyAddonsUSDMedium,
  LA: addons.familyAddonsUSDMedium,
  LB: addons.familyAddonsUSDMedium,
  LC: addons.familyAddonsUSDMedium,
  LI: addons.familyAddonsUSDMedium,
  LK: addons.familyAddonsUSDMedium,
  LS: addons.familyAddonsUSDMedium,
  LT: addons.familyAddonsUSDMedium,
  LV: addons.familyAddonsUSDMedium,
  LY: addons.familyAddonsUSDMedium,
  MA: addons.familyAddonsUSDMedium,
  MC: addons.familyAddonsUSDMedium,
  MD: addons.familyAddonsUSDMedium,
  ME: addons.familyAddonsUSDMedium,
  MG: addons.familyAddonsUSDMedium,
  MK: addons.familyAddonsUSDMedium,
  ML: addons.familyAddonsUSDMedium,
  MM: addons.familyAddonsUSDMedium,
  MN: addons.familyAddonsUSDMedium,
  MO: addons.familyAddonsUSDMedium,
  MQ: addons.familyAddonsUSDMedium,
  MR: addons.familyAddonsUSDMedium,
  MT: addons.familyAddonsUSDMedium,
  MU: addons.familyAddonsUSDMedium,
  MV: addons.familyAddonsUSDMedium,
  MW: addons.familyAddonsUSDMedium,
  MX: addons.familyAddonsUSDMedium,
  MY: addons.familyAddonsUSDMedium,
  MZ: addons.familyAddonsUSDMedium,
  NA: addons.familyAddonsUSDMedium,
  NC: addons.familyAddonsUSDMedium,
  NE: addons.familyAddonsUSDMedium,
  NF: addons.familyAddonsUSDMedium,
  NG: addons.familyAddonsUSDMedium,
  NI: addons.familyAddonsUSDMedium,
  NP: addons.familyAddonsUSDMedium,
  NZ: addons.familyAddonsUSDMedium,
  PA: addons.familyAddonsUSDMedium,
  PE: addons.familyAddonsUSDMedium,
  PF: addons.familyAddonsUSDMedium,
  PG: addons.familyAddonsUSDMedium,
  PH: addons.familyAddonsUSDMedium,
  PK: addons.familyAddonsUSDMedium,
  PR: addons.familyAddonsUSDMedium,
  PS: addons.familyAddonsUSDMedium,
  PY: addons.familyAddonsUSDMedium,
  RE: addons.familyAddonsUSDMedium,
  RS: addons.familyAddonsUSDMedium,
  RU: addons.familyAddonsUSDMedium,
  RW: addons.familyAddonsUSDMedium,
  SC: addons.familyAddonsUSDMedium,
  SD: addons.familyAddonsUSDMedium,
  SG: addons.familyAddonsUSDMedium,
  SI: addons.familyAddonsUSDMedium,
  SK: addons.familyAddonsUSDMedium,
  SL: addons.familyAddonsUSDMedium,
  SM: addons.familyAddonsUSDMedium,
  SN: addons.familyAddonsUSDMedium,
  SO: addons.familyAddonsUSDMedium,
  SS: addons.familyAddonsUSDMedium,
  SV: addons.familyAddonsUSDMedium,
  SY: addons.familyAddonsUSDMedium,
  SZ: addons.familyAddonsUSDMedium,
  TD: addons.familyAddonsUSDMedium,
  TG: addons.familyAddonsUSDMedium,
  TH: addons.familyAddonsUSDMedium,
  TJ: addons.familyAddonsUSDMedium,
  TL: addons.familyAddonsUSDMedium,
  TN: addons.familyAddonsUSDMedium,
  TR: addons.familyAddonsUSDMedium,
  TV: addons.familyAddonsUSDMedium,
  TW: addons.familyAddonsUSDMedium,
  TZ: addons.familyAddonsUSDMedium,
  UA: addons.familyAddonsUSDMedium,
  UG: addons.familyAddonsUSDMedium,
  UY: addons.familyAddonsUSDMedium,
  UZ: addons.familyAddonsUSDMedium,
  VC: addons.familyAddonsUSDMedium,
  VE: addons.familyAddonsUSDMedium,
  VG: addons.familyAddonsUSDMedium,
  VI: addons.familyAddonsUSDMedium,
  VN: addons.familyAddonsUSDMedium,
  VU: addons.familyAddonsUSDMedium,
  XK: addons.familyAddonsUSDMedium,
  YE: addons.familyAddonsUSDMedium,
  YT: addons.familyAddonsUSDMedium,
  ZA: addons.familyAddonsUSDMedium,
  ZM: addons.familyAddonsUSDMedium,
  ZW: addons.familyAddonsUSDMedium,
  AE: addons.familyAddonsUS,
  BH: addons.familyAddonsUS,
  BN: addons.familyAddonsUS,
  BW: addons.familyAddonsUS,
  BZ: addons.familyAddonsUS,
  EE: addons.familyAddonsUS,
  GY: addons.familyAddonsUS,
  KW: addons.familyAddonsUS,
  KZ: addons.familyAddonsUS,
  LU: addons.familyAddonsUS,
  OM: addons.familyAddonsUS,
  QA: addons.familyAddonsUS,
  SA: addons.familyAddonsUS,
  SR: addons.familyAddonsUS,
  TM: addons.familyAddonsUS,
  TT: addons.familyAddonsUS,
  AT: addons.familyAddonsEU,
  BE: addons.familyAddonsEU,
  CY: addons.familyAddonsEU,
  DK: addons.familyAddonsEU,
  FI: addons.familyAddonsEU,
  FR: addons.familyAddonsEU,
  DE: addons.familyAddonsEU,
  IT: addons.familyAddonsEU,
  IE: addons.familyAddonsEU,
  NL: addons.familyAddonsEU,
  NO: addons.familyAddonsEU,
  PL: addons.familyAddonsEU,
  ES: addons.familyAddonsEU,
  SE: addons.familyAddonsEU,
  CH: addons.familyAddonsEU,
  CZ: addons.familyAddonsEU,
  HU: addons.familyAddonsEU,
  PT: addons.familyAddonsEU,
  BG: addons.familyAddonsEU,
  RO: addons.familyAddonsEU,
} as {
  [country in Country]: addons.Addons;
};

const businessPlanOptions: {
  [country in Country]: string;
} = {
  AU: plans.businessPlanIdAU,
  CA: plans.businessPlanIdCA,
  EU: plans.businessPlanIdEU,
  GB: plans.businessPlanIdGB,
  US: plans.businessPlanIdUS,
  AD: plans.businessPlanIdUSDMedium,
  AF: plans.businessPlanIdUSDMedium,
  AG: plans.businessPlanIdUSDMedium,
  AL: plans.businessPlanIdUSDMedium,
  AM: plans.businessPlanIdUSDMedium,
  AO: plans.businessPlanIdUSDMedium,
  AQ: plans.businessPlanIdUSDMedium,
  AR: plans.businessPlanIdUSDMedium,
  AW: plans.businessPlanIdUSDMedium,
  AZ: plans.businessPlanIdUSDMedium,
  BA: plans.businessPlanIdUSDMedium,
  BB: plans.businessPlanIdUSDMedium,
  BD: plans.businessPlanIdUSDMedium,
  BF: plans.businessPlanIdUSDMedium,
  BI: plans.businessPlanIdUSDMedium,
  BJ: plans.businessPlanIdUSDMedium,
  BM: plans.businessPlanIdUSDMedium,
  BO: plans.businessPlanIdUSDMedium,
  BQ: plans.businessPlanIdUSDMedium,
  BR: plans.businessPlanIdUSDMedium,
  BS: plans.businessPlanIdUSDMedium,
  BT: plans.businessPlanIdUSDMedium,
  BY: plans.businessPlanIdUSDMedium,
  CD: plans.businessPlanIdUSDMedium,
  CI: plans.businessPlanIdUSDMedium,
  CL: plans.businessPlanIdUSDMedium,
  CM: plans.businessPlanIdUSDMedium,
  CN: plans.businessPlanIdUSDMedium,
  CO: plans.businessPlanIdUSDMedium,
  CR: plans.businessPlanIdUSDMedium,
  CU: plans.businessPlanIdUSDMedium,
  CV: plans.businessPlanIdUSDMedium,
  CW: plans.businessPlanIdUSDMedium,
  DO: plans.businessPlanIdUSDMedium,
  DZ: plans.businessPlanIdUSDMedium,
  EC: plans.businessPlanIdUSDMedium,
  EG: plans.businessPlanIdUSDMedium,
  EH: plans.businessPlanIdUSDMedium,
  ET: plans.businessPlanIdUSDMedium,
  FJ: plans.businessPlanIdUSDMedium,
  FK: plans.businessPlanIdUSDMedium,
  FM: plans.businessPlanIdUSDMedium,
  FO: plans.businessPlanIdUSDMedium,
  GA: plans.businessPlanIdUSDMedium,
  GD: plans.businessPlanIdUSDMedium,
  GE: plans.businessPlanIdUSDMedium,
  GG: plans.businessPlanIdUSDMedium,
  GH: plans.businessPlanIdUSDMedium,
  GI: plans.businessPlanIdUSDMedium,
  GM: plans.businessPlanIdUSDMedium,
  GP: plans.businessPlanIdUSDMedium,
  GQ: plans.businessPlanIdUSDMedium,
  GR: plans.businessPlanIdUSDMedium,
  GT: plans.businessPlanIdUSDMedium,
  GU: plans.businessPlanIdUSDMedium,
  HK: plans.businessPlanIdUSDMedium,
  HN: plans.businessPlanIdUSDMedium,
  HR: plans.businessPlanIdUSDMedium,
  HT: plans.businessPlanIdUSDMedium,
  ID: plans.businessPlanIdUSDMedium,
  IL: plans.businessPlanIdUSDMedium,
  IN: plans.businessPlanIdUSDMedium,
  IQ: plans.businessPlanIdUSDMedium,
  IR: plans.businessPlanIdUSDMedium,
  IS: plans.businessPlanIdUSDMedium,
  JE: plans.businessPlanIdUSDMedium,
  JM: plans.businessPlanIdUSDMedium,
  JO: plans.businessPlanIdUSDMedium,
  JP: plans.businessPlanIdUSDMedium,
  KE: plans.businessPlanIdUSDMedium,
  KG: plans.businessPlanIdUSDMedium,
  KH: plans.businessPlanIdUSDMedium,
  KN: plans.businessPlanIdUSDMedium,
  KR: plans.businessPlanIdUSDMedium,
  KY: plans.businessPlanIdUSDMedium,
  LA: plans.businessPlanIdUSDMedium,
  LB: plans.businessPlanIdUSDMedium,
  LC: plans.businessPlanIdUSDMedium,
  LI: plans.businessPlanIdUSDMedium,
  LK: plans.businessPlanIdUSDMedium,
  LS: plans.businessPlanIdUSDMedium,
  LT: plans.businessPlanIdUSDMedium,
  LV: plans.businessPlanIdUSDMedium,
  LY: plans.businessPlanIdUSDMedium,
  MA: plans.businessPlanIdUSDMedium,
  MC: plans.businessPlanIdUSDMedium,
  MD: plans.businessPlanIdUSDMedium,
  ME: plans.businessPlanIdUSDMedium,
  MG: plans.businessPlanIdUSDMedium,
  MK: plans.businessPlanIdUSDMedium,
  ML: plans.businessPlanIdUSDMedium,
  MM: plans.businessPlanIdUSDMedium,
  MN: plans.businessPlanIdUSDMedium,
  MO: plans.businessPlanIdUSDMedium,
  MQ: plans.businessPlanIdUSDMedium,
  MR: plans.businessPlanIdUSDMedium,
  MT: plans.businessPlanIdUSDMedium,
  MU: plans.businessPlanIdUSDMedium,
  MV: plans.businessPlanIdUSDMedium,
  MW: plans.businessPlanIdUSDMedium,
  MX: plans.businessPlanIdUSDMedium,
  MY: plans.businessPlanIdUSDMedium,
  MZ: plans.businessPlanIdUSDMedium,
  NA: plans.businessPlanIdUSDMedium,
  NC: plans.businessPlanIdUSDMedium,
  NE: plans.businessPlanIdUSDMedium,
  NF: plans.businessPlanIdUSDMedium,
  NG: plans.businessPlanIdUSDMedium,
  NI: plans.businessPlanIdUSDMedium,
  NP: plans.businessPlanIdUSDMedium,
  NZ: plans.businessPlanIdUSDMedium,
  PA: plans.businessPlanIdUSDMedium,
  PE: plans.businessPlanIdUSDMedium,
  PF: plans.businessPlanIdUSDMedium,
  PG: plans.businessPlanIdUSDMedium,
  PH: plans.businessPlanIdUSDMedium,
  PK: plans.businessPlanIdUSDMedium,
  PR: plans.businessPlanIdUSDMedium,
  PS: plans.businessPlanIdUSDMedium,
  PY: plans.businessPlanIdUSDMedium,
  RE: plans.businessPlanIdUSDMedium,
  RS: plans.businessPlanIdUSDMedium,
  RU: plans.businessPlanIdUSDMedium,
  RW: plans.businessPlanIdUSDMedium,
  SC: plans.businessPlanIdUSDMedium,
  SD: plans.businessPlanIdUSDMedium,
  SG: plans.businessPlanIdUSDMedium,
  SI: plans.businessPlanIdUSDMedium,
  SK: plans.businessPlanIdUSDMedium,
  SL: plans.businessPlanIdUSDMedium,
  SM: plans.businessPlanIdUSDMedium,
  SN: plans.businessPlanIdUSDMedium,
  SO: plans.businessPlanIdUSDMedium,
  SS: plans.businessPlanIdUSDMedium,
  SV: plans.businessPlanIdUSDMedium,
  SY: plans.businessPlanIdUSDMedium,
  SZ: plans.businessPlanIdUSDMedium,
  TD: plans.businessPlanIdUSDMedium,
  TG: plans.businessPlanIdUSDMedium,
  TH: plans.businessPlanIdUSDMedium,
  TJ: plans.businessPlanIdUSDMedium,
  TL: plans.businessPlanIdUSDMedium,
  TN: plans.businessPlanIdUSDMedium,
  TR: plans.businessPlanIdUSDMedium,
  TV: plans.businessPlanIdUSDMedium,
  TW: plans.businessPlanIdUSDMedium,
  TZ: plans.businessPlanIdUSDMedium,
  UA: plans.businessPlanIdUSDMedium,
  UG: plans.businessPlanIdUSDMedium,
  UY: plans.businessPlanIdUSDMedium,
  UZ: plans.businessPlanIdUSDMedium,
  VC: plans.businessPlanIdUSDMedium,
  VE: plans.businessPlanIdUSDMedium,
  VG: plans.businessPlanIdUSDMedium,
  VI: plans.businessPlanIdUSDMedium,
  VN: plans.businessPlanIdUSDMedium,
  VU: plans.businessPlanIdUSDMedium,
  XK: plans.businessPlanIdUSDMedium,
  YE: plans.businessPlanIdUSDMedium,
  YT: plans.businessPlanIdUSDMedium,
  ZA: plans.businessPlanIdUSDMedium,
  ZM: plans.businessPlanIdUSDMedium,
  ZW: plans.businessPlanIdUSDMedium,
  AE: plans.businessPlanIdUS,
  BH: plans.businessPlanIdUS,
  BN: plans.businessPlanIdUS,
  BW: plans.businessPlanIdUS,
  BZ: plans.businessPlanIdUS,
  EE: plans.businessPlanIdUS,
  GY: plans.businessPlanIdUS,
  KW: plans.businessPlanIdUS,
  KZ: plans.businessPlanIdUS,
  LU: plans.businessPlanIdUS,
  OM: plans.businessPlanIdUS,
  QA: plans.businessPlanIdUS,
  SA: plans.businessPlanIdUS,
  SR: plans.businessPlanIdUS,
  TM: plans.businessPlanIdUS,
  TT: plans.businessPlanIdUS,
  AT: plans.businessPlanIdEU,
  BE: plans.businessPlanIdEU,
  CY: plans.businessPlanIdEU,
  DK: plans.businessPlanIdEU,
  FI: plans.businessPlanIdEU,
  FR: plans.businessPlanIdEU,
  DE: plans.businessPlanIdEU,
  IT: plans.businessPlanIdEU,
  IE: plans.businessPlanIdEU,
  NL: plans.businessPlanIdEU,
  NO: plans.businessPlanIdEU,
  PL: plans.businessPlanIdEU,
  ES: plans.businessPlanIdEU,
  SE: plans.businessPlanIdEU,
  CH: plans.businessPlanIdEU,
  CZ: plans.businessPlanIdEU,
  HU: plans.businessPlanIdEU,
  PT: plans.businessPlanIdEU,
  BG: plans.businessPlanIdEU,
  RO: plans.businessPlanIdEU,
};

const businessAddonOptions = {
  AU: addons.businessAddonsAU,
  CA: addons.businessAddonsCA,
  EU: addons.businessAddonsEU,
  GB: addons.businessAddonsGB,
  US: addons.businessAddonsUS,
  AD: addons.businessAddonsUSDMedium,
  AF: addons.businessAddonsUSDMedium,
  AG: addons.businessAddonsUSDMedium,
  AL: addons.businessAddonsUSDMedium,
  AM: addons.businessAddonsUSDMedium,
  AO: addons.businessAddonsUSDMedium,
  AQ: addons.businessAddonsUSDMedium,
  AR: addons.businessAddonsUSDMedium,
  AW: addons.businessAddonsUSDMedium,
  AZ: addons.businessAddonsUSDMedium,
  BA: addons.businessAddonsUSDMedium,
  BB: addons.businessAddonsUSDMedium,
  BD: addons.businessAddonsUSDMedium,
  BF: addons.businessAddonsUSDMedium,
  BI: addons.businessAddonsUSDMedium,
  BJ: addons.businessAddonsUSDMedium,
  BM: addons.businessAddonsUSDMedium,
  BO: addons.businessAddonsUSDMedium,
  BQ: addons.businessAddonsUSDMedium,
  BR: addons.businessAddonsUSDMedium,
  BS: addons.businessAddonsUSDMedium,
  BT: addons.businessAddonsUSDMedium,
  BY: addons.businessAddonsUSDMedium,
  CD: addons.businessAddonsUSDMedium,
  CI: addons.businessAddonsUSDMedium,
  CL: addons.businessAddonsUSDMedium,
  CM: addons.businessAddonsUSDMedium,
  CN: addons.businessAddonsUSDMedium,
  CO: addons.businessAddonsUSDMedium,
  CR: addons.businessAddonsUSDMedium,
  CU: addons.businessAddonsUSDMedium,
  CV: addons.businessAddonsUSDMedium,
  CW: addons.businessAddonsUSDMedium,
  DO: addons.businessAddonsUSDMedium,
  DZ: addons.businessAddonsUSDMedium,
  EC: addons.businessAddonsUSDMedium,
  EG: addons.businessAddonsUSDMedium,
  EH: addons.businessAddonsUSDMedium,
  ET: addons.businessAddonsUSDMedium,
  FJ: addons.businessAddonsUSDMedium,
  FK: addons.businessAddonsUSDMedium,
  FM: addons.businessAddonsUSDMedium,
  FO: addons.businessAddonsUSDMedium,
  GA: addons.businessAddonsUSDMedium,
  GD: addons.businessAddonsUSDMedium,
  GE: addons.businessAddonsUSDMedium,
  GG: addons.businessAddonsUSDMedium,
  GH: addons.businessAddonsUSDMedium,
  GI: addons.businessAddonsUSDMedium,
  GM: addons.businessAddonsUSDMedium,
  GP: addons.businessAddonsUSDMedium,
  GQ: addons.businessAddonsUSDMedium,
  GR: addons.businessAddonsUSDMedium,
  GT: addons.businessAddonsUSDMedium,
  GU: addons.businessAddonsUSDMedium,
  HK: addons.businessAddonsUSDMedium,
  HN: addons.businessAddonsUSDMedium,
  HR: addons.businessAddonsUSDMedium,
  HT: addons.businessAddonsUSDMedium,
  ID: addons.businessAddonsUSDMedium,
  IL: addons.businessAddonsUSDMedium,
  IN: addons.businessAddonsUSDMedium,
  IQ: addons.businessAddonsUSDMedium,
  IR: addons.businessAddonsUSDMedium,
  IS: addons.businessAddonsUSDMedium,
  JE: addons.businessAddonsUSDMedium,
  JM: addons.businessAddonsUSDMedium,
  JO: addons.businessAddonsUSDMedium,
  JP: addons.businessAddonsUSDMedium,
  KE: addons.businessAddonsUSDMedium,
  KG: addons.businessAddonsUSDMedium,
  KH: addons.businessAddonsUSDMedium,
  KN: addons.businessAddonsUSDMedium,
  KR: addons.businessAddonsUSDMedium,
  KY: addons.businessAddonsUSDMedium,
  LA: addons.businessAddonsUSDMedium,
  LB: addons.businessAddonsUSDMedium,
  LC: addons.businessAddonsUSDMedium,
  LI: addons.businessAddonsUSDMedium,
  LK: addons.businessAddonsUSDMedium,
  LS: addons.businessAddonsUSDMedium,
  LT: addons.businessAddonsUSDMedium,
  LV: addons.businessAddonsUSDMedium,
  LY: addons.businessAddonsUSDMedium,
  MA: addons.businessAddonsUSDMedium,
  MC: addons.businessAddonsUSDMedium,
  MD: addons.businessAddonsUSDMedium,
  ME: addons.businessAddonsUSDMedium,
  MG: addons.businessAddonsUSDMedium,
  MK: addons.businessAddonsUSDMedium,
  ML: addons.businessAddonsUSDMedium,
  MM: addons.businessAddonsUSDMedium,
  MN: addons.businessAddonsUSDMedium,
  MO: addons.businessAddonsUSDMedium,
  MQ: addons.businessAddonsUSDMedium,
  MR: addons.businessAddonsUSDMedium,
  MT: addons.businessAddonsUSDMedium,
  MU: addons.businessAddonsUSDMedium,
  MV: addons.businessAddonsUSDMedium,
  MW: addons.businessAddonsUSDMedium,
  MX: addons.businessAddonsUSDMedium,
  MY: addons.businessAddonsUSDMedium,
  MZ: addons.businessAddonsUSDMedium,
  NA: addons.businessAddonsUSDMedium,
  NC: addons.businessAddonsUSDMedium,
  NE: addons.businessAddonsUSDMedium,
  NF: addons.businessAddonsUSDMedium,
  NG: addons.businessAddonsUSDMedium,
  NI: addons.businessAddonsUSDMedium,
  NP: addons.businessAddonsUSDMedium,
  NZ: addons.businessAddonsUSDMedium,
  PA: addons.businessAddonsUSDMedium,
  PE: addons.businessAddonsUSDMedium,
  PF: addons.businessAddonsUSDMedium,
  PG: addons.businessAddonsUSDMedium,
  PH: addons.businessAddonsUSDMedium,
  PK: addons.businessAddonsUSDMedium,
  PR: addons.businessAddonsUSDMedium,
  PS: addons.businessAddonsUSDMedium,
  PY: addons.businessAddonsUSDMedium,
  RE: addons.businessAddonsUSDMedium,
  RS: addons.businessAddonsUSDMedium,
  RU: addons.businessAddonsUSDMedium,
  RW: addons.businessAddonsUSDMedium,
  SC: addons.businessAddonsUSDMedium,
  SD: addons.businessAddonsUSDMedium,
  SG: addons.businessAddonsUSDMedium,
  SI: addons.businessAddonsUSDMedium,
  SK: addons.businessAddonsUSDMedium,
  SL: addons.businessAddonsUSDMedium,
  SM: addons.businessAddonsUSDMedium,
  SN: addons.businessAddonsUSDMedium,
  SO: addons.businessAddonsUSDMedium,
  SS: addons.businessAddonsUSDMedium,
  SV: addons.businessAddonsUSDMedium,
  SY: addons.businessAddonsUSDMedium,
  SZ: addons.businessAddonsUSDMedium,
  TD: addons.businessAddonsUSDMedium,
  TG: addons.businessAddonsUSDMedium,
  TH: addons.businessAddonsUSDMedium,
  TJ: addons.businessAddonsUSDMedium,
  TL: addons.businessAddonsUSDMedium,
  TN: addons.businessAddonsUSDMedium,
  TR: addons.businessAddonsUSDMedium,
  TV: addons.businessAddonsUSDMedium,
  TW: addons.businessAddonsUSDMedium,
  TZ: addons.businessAddonsUSDMedium,
  UA: addons.businessAddonsUSDMedium,
  UG: addons.businessAddonsUSDMedium,
  UY: addons.businessAddonsUSDMedium,
  UZ: addons.businessAddonsUSDMedium,
  VC: addons.businessAddonsUSDMedium,
  VE: addons.businessAddonsUSDMedium,
  VG: addons.businessAddonsUSDMedium,
  VI: addons.businessAddonsUSDMedium,
  VN: addons.businessAddonsUSDMedium,
  VU: addons.businessAddonsUSDMedium,
  XK: addons.businessAddonsUSDMedium,
  YE: addons.businessAddonsUSDMedium,
  YT: addons.businessAddonsUSDMedium,
  ZA: addons.businessAddonsUSDMedium,
  ZM: addons.businessAddonsUSDMedium,
  ZW: addons.businessAddonsUSDMedium,
  AE: addons.businessAddonsUS,
  BH: addons.businessAddonsUS,
  BN: addons.businessAddonsUS,
  BW: addons.businessAddonsUS,
  BZ: addons.businessAddonsUS,
  EE: addons.businessAddonsUS,
  GY: addons.businessAddonsUS,
  KW: addons.businessAddonsUS,
  KZ: addons.businessAddonsUS,
  LU: addons.businessAddonsUS,
  OM: addons.businessAddonsUS,
  QA: addons.businessAddonsUS,
  SA: addons.businessAddonsUS,
  SR: addons.businessAddonsUS,
  TM: addons.businessAddonsUS,
  TT: addons.businessAddonsUS,
  AT: addons.businessAddonsEU,
  BE: addons.businessAddonsEU,
  CY: addons.businessAddonsEU,
  DK: addons.businessAddonsEU,
  FI: addons.businessAddonsEU,
  FR: addons.businessAddonsEU,
  DE: addons.businessAddonsEU,
  IT: addons.businessAddonsEU,
  IE: addons.businessAddonsEU,
  NL: addons.businessAddonsEU,
  NO: addons.businessAddonsEU,
  PL: addons.businessAddonsEU,
  ES: addons.businessAddonsEU,
  SE: addons.businessAddonsEU,
  CH: addons.businessAddonsEU,
  CZ: addons.businessAddonsEU,
  HU: addons.businessAddonsEU,
  PT: addons.businessAddonsEU,
  BG: addons.businessAddonsEU,
  RO: addons.businessAddonsEU,
} as {
  [country in Country]: addons.Addons;
};

export const locationConsumptions: {
  [country in Country]: string;
} = {
  AD: Consumptions.HIGH,
  AE: Consumptions.VERY_HIGH,
  AF: Consumptions.HIGH,
  AG: Consumptions.HIGH,
  AL: Consumptions.HIGH,
  AM: Consumptions.HIGH,
  AO: Consumptions.HIGH,
  AQ: Consumptions.HIGH,
  AR: Consumptions.HIGH,
  AT: Consumptions.HIGH,
  AU: Consumptions.VERY_HIGH,
  AW: Consumptions.HIGH,
  AZ: Consumptions.HIGH,
  BA: Consumptions.HIGH,
  BB: Consumptions.HIGH,
  BD: Consumptions.HIGH,
  BE: Consumptions.HIGH,
  BF: Consumptions.HIGH,
  BG: Consumptions.HIGH,
  BH: Consumptions.VERY_HIGH,
  BI: Consumptions.HIGH,
  BJ: Consumptions.HIGH,
  BM: Consumptions.HIGH,
  BN: Consumptions.VERY_HIGH,
  BO: Consumptions.HIGH,
  BQ: Consumptions.HIGH,
  BR: Consumptions.HIGH,
  BS: Consumptions.HIGH,
  BT: Consumptions.HIGH,
  BW: Consumptions.VERY_HIGH,
  BY: Consumptions.HIGH,
  BZ: Consumptions.VERY_HIGH,
  CA: Consumptions.VERY_HIGH,
  CD: Consumptions.HIGH,
  CH: Consumptions.HIGH,
  CI: Consumptions.HIGH,
  CL: Consumptions.HIGH,
  CM: Consumptions.HIGH,
  CN: Consumptions.HIGH,
  CO: Consumptions.HIGH,
  CR: Consumptions.HIGH,
  CU: Consumptions.HIGH,
  CV: Consumptions.HIGH,
  CW: Consumptions.HIGH,
  CY: Consumptions.HIGH,
  CZ: Consumptions.HIGH,
  DE: Consumptions.HIGH,
  DK: Consumptions.HIGH,
  DO: Consumptions.HIGH,
  DZ: Consumptions.HIGH,
  EC: Consumptions.HIGH,
  EE: Consumptions.VERY_HIGH,
  EG: Consumptions.HIGH,
  EH: Consumptions.HIGH,
  ES: Consumptions.HIGH,
  ET: Consumptions.HIGH,
  EU: Consumptions.HIGH,
  FI: Consumptions.HIGH,
  FJ: Consumptions.HIGH,
  FK: Consumptions.HIGH,
  FM: Consumptions.HIGH,
  FO: Consumptions.HIGH,
  FR: Consumptions.HIGH,
  GA: Consumptions.HIGH,
  GB: Consumptions.HIGH,
  GD: Consumptions.HIGH,
  GE: Consumptions.HIGH,
  GG: Consumptions.HIGH,
  GH: Consumptions.HIGH,
  GI: Consumptions.HIGH,
  GM: Consumptions.HIGH,
  GP: Consumptions.HIGH,
  GQ: Consumptions.HIGH,
  GR: Consumptions.HIGH,
  GT: Consumptions.HIGH,
  GU: Consumptions.HIGH,
  GY: Consumptions.VERY_HIGH,
  HK: Consumptions.HIGH,
  HN: Consumptions.HIGH,
  HR: Consumptions.HIGH,
  HT: Consumptions.HIGH,
  HU: Consumptions.HIGH,
  ID: Consumptions.HIGH,
  IE: Consumptions.HIGH,
  IL: Consumptions.HIGH,
  IN: Consumptions.HIGH,
  IQ: Consumptions.HIGH,
  IR: Consumptions.HIGH,
  IS: Consumptions.HIGH,
  IT: Consumptions.HIGH,
  JE: Consumptions.HIGH,
  JM: Consumptions.HIGH,
  JO: Consumptions.HIGH,
  JP: Consumptions.HIGH,
  KE: Consumptions.HIGH,
  KG: Consumptions.HIGH,
  KH: Consumptions.HIGH,
  KN: Consumptions.HIGH,
  KR: Consumptions.HIGH,
  KW: Consumptions.VERY_HIGH,
  KY: Consumptions.HIGH,
  KZ: Consumptions.VERY_HIGH,
  LA: Consumptions.HIGH,
  LB: Consumptions.HIGH,
  LC: Consumptions.HIGH,
  LI: Consumptions.HIGH,
  LK: Consumptions.HIGH,
  LS: Consumptions.HIGH,
  LT: Consumptions.HIGH,
  LU: Consumptions.VERY_HIGH,
  LV: Consumptions.HIGH,
  LY: Consumptions.HIGH,
  MA: Consumptions.HIGH,
  MC: Consumptions.HIGH,
  MD: Consumptions.HIGH,
  ME: Consumptions.HIGH,
  MG: Consumptions.HIGH,
  MK: Consumptions.HIGH,
  ML: Consumptions.HIGH,
  MM: Consumptions.HIGH,
  MN: Consumptions.HIGH,
  MO: Consumptions.HIGH,
  MQ: Consumptions.HIGH,
  MR: Consumptions.HIGH,
  MT: Consumptions.HIGH,
  MU: Consumptions.HIGH,
  MV: Consumptions.HIGH,
  MW: Consumptions.HIGH,
  MX: Consumptions.HIGH,
  MY: Consumptions.HIGH,
  MZ: Consumptions.HIGH,
  NA: Consumptions.HIGH,
  NC: Consumptions.HIGH,
  NE: Consumptions.HIGH,
  NF: Consumptions.HIGH,
  NG: Consumptions.HIGH,
  NI: Consumptions.HIGH,
  NL: Consumptions.HIGH,
  NO: Consumptions.HIGH,
  NP: Consumptions.HIGH,
  NZ: Consumptions.HIGH,
  OM: Consumptions.VERY_HIGH,
  PA: Consumptions.HIGH,
  PE: Consumptions.HIGH,
  PF: Consumptions.HIGH,
  PG: Consumptions.HIGH,
  PH: Consumptions.HIGH,
  PK: Consumptions.HIGH,
  PL: Consumptions.HIGH,
  PR: Consumptions.HIGH,
  PS: Consumptions.HIGH,
  PT: Consumptions.HIGH,
  PY: Consumptions.HIGH,
  QA: Consumptions.VERY_HIGH,
  RE: Consumptions.HIGH,
  RO: Consumptions.HIGH,
  RS: Consumptions.HIGH,
  RU: Consumptions.HIGH,
  RW: Consumptions.HIGH,
  SA: Consumptions.VERY_HIGH,
  SC: Consumptions.HIGH,
  SD: Consumptions.HIGH,
  SE: Consumptions.HIGH,
  SG: Consumptions.HIGH,
  SI: Consumptions.HIGH,
  SK: Consumptions.HIGH,
  SL: Consumptions.HIGH,
  SM: Consumptions.HIGH,
  SN: Consumptions.HIGH,
  SO: Consumptions.HIGH,
  SR: Consumptions.VERY_HIGH,
  SS: Consumptions.HIGH,
  SV: Consumptions.HIGH,
  SY: Consumptions.HIGH,
  SZ: Consumptions.HIGH,
  TD: Consumptions.HIGH,
  TG: Consumptions.HIGH,
  TH: Consumptions.HIGH,
  TJ: Consumptions.HIGH,
  TL: Consumptions.HIGH,
  TM: Consumptions.VERY_HIGH,
  TN: Consumptions.HIGH,
  TR: Consumptions.HIGH,
  TT: Consumptions.VERY_HIGH,
  TV: Consumptions.HIGH,
  TW: Consumptions.HIGH,
  TZ: Consumptions.HIGH,
  UA: Consumptions.HIGH,
  UG: Consumptions.HIGH,
  US: Consumptions.VERY_HIGH,
  UY: Consumptions.HIGH,
  UZ: Consumptions.HIGH,
  VC: Consumptions.HIGH,
  VE: Consumptions.HIGH,
  VG: Consumptions.HIGH,
  VI: Consumptions.HIGH,
  VN: Consumptions.HIGH,
  VU: Consumptions.HIGH,
  XK: Consumptions.HIGH,
  YE: Consumptions.HIGH,
  YT: Consumptions.HIGH,
  ZA: Consumptions.HIGH,
  ZM: Consumptions.HIGH,
  ZW: Consumptions.HIGH,
};

export const veryHighImpactCountries = Object.keys(locationConsumptions).filter(c => {
  const countryConsumption = locationConsumptions[c as Country] as Consumptions;
  return countryConsumption === Consumptions.VERY_HIGH;
});

export const highFootprint = 8;
export const veryHighFootprint = 17;

/**
 * Determine if the location can be used with the USMedium plans (personal, business, family)
 * @param {Location} location
 */
export const isUSMediumLocation = (location: Location) => {
  const usMediumSet: { [country in Country]?: true } = {
    AD: true,
    AF: true,
    AG: true,
    AL: true,
    AM: true,
    AO: true,
    AQ: true,
    AR: true,
    AW: true,
    AZ: true,
    BA: true,
    BB: true,
    BD: true,
    BF: true,
    BI: true,
    BJ: true,
    BM: true,
    BO: true,
    BQ: true,
    BR: true,
    BS: true,
    BT: true,
    BY: true,
    CD: true,
    CI: true,
    CL: true,
    CM: true,
    CN: true,
    CO: true,
    CR: true,
    CU: true,
    CV: true,
    CW: true,
    DO: true,
    DZ: true,
    EC: true,
    EG: true,
    EH: true,
    ET: true,
    FJ: true,
    FK: true,
    FM: true,
    FO: true,
    GA: true,
    GD: true,
    GE: true,
    GG: true,
    GH: true,
    GI: true,
    GM: true,
    GP: true,
    GQ: true,
    GR: true,
    GT: true,
    GU: true,
    HK: true,
    HN: true,
    HR: true,
    HT: true,
    ID: true,
    IL: true,
    IN: true,
    IQ: true,
    IR: true,
    IS: true,
    JE: true,
    JM: true,
    JO: true,
    JP: true,
    KE: true,
    KG: true,
    KH: true,
    KN: true,
    KR: true,
    KY: true,
    LA: true,
    LB: true,
    LC: true,
    LI: true,
    LK: true,
    LS: true,
    LT: true,
    LV: true,
    LY: true,
    MA: true,
    MC: true,
    MD: true,
    ME: true,
    MG: true,
    MK: true,
    ML: true,
    MM: true,
    MN: true,
    MO: true,
    MQ: true,
    MR: true,
    MT: true,
    MU: true,
    MV: true,
    MW: true,
    MX: true,
    MY: true,
    MZ: true,
    NA: true,
    NC: true,
    NE: true,
    NF: true,
    NG: true,
    NI: true,
    NP: true,
    NZ: true,
    PA: true,
    PE: true,
    PF: true,
    PG: true,
    PH: true,
    PK: true,
    PR: true,
    PS: true,
    PY: true,
    RE: true,
    RS: true,
    RU: true,
    RW: true,
    SC: true,
    SD: true,
    SG: true,
    SI: true,
    SK: true,
    SL: true,
    SM: true,
    SN: true,
    SO: true,
    SS: true,
    SV: true,
    SY: true,
    SZ: true,
    TD: true,
    TG: true,
    TH: true,
    TJ: true,
    TL: true,
    TN: true,
    TR: true,
    TV: true,
    TW: true,
    TZ: true,
    UA: true,
    UG: true,
    UY: true,
    UZ: true,
    VC: true,
    VE: true,
    VG: true,
    VI: true,
    VN: true,
    VU: true,
    XK: true,
    YE: true,
    YT: true,
    ZA: true,
    ZM: true,
    ZW: true,
  };

  return usMediumSet[location.countryCode] == true;
};

export const getCurrencySymbol = (countryCode: Country) => {
  const currencyCode = locationCurrencyCodeMapper[countryCode];
  return currencySymbols[currencyCode];
};

export const getLocationPlans = (location: Location | null) => {
  const countryCode = transformLocationIntoValidPlanCountryCode(location);

  const currencyCode = locationCurrencyCodeMapper[countryCode];
  const plansForLocation = plansForLocations[countryCode];
  const locationConsumption = locationConsumptions[countryCode];
  const numTonnesPerPerson = locationConsumption === Consumptions.VERY_HIGH ? veryHighFootprint : highFootprint;

  return {
    businessAddonsForLocation: businessAddonOptions[countryCode],
    businessPlanIdForLocation: businessPlanOptions[countryCode],
    currencyCode,
    currencySymbol: currencySymbols[currencyCode],
    familyAddonsForLocation: familyAddonsForLocations[countryCode],
    familyPlanIdForLocation: familyPlanIdsForLocation[countryCode],
    locationName: locationNames[countryCode],
    locationConsumption,
    numTonnesPerPerson,
    plansForLocation,
    localProjectAddon: projectLocationAddonMapper[countryCode],
  };
};

/**
 * When someone is redeeming a gift card they will be creating a new subscription against a basic / personal plan
 * Retrieve the listing of personal plan ids by country / location
 * @param {Location | null} location
 * @returns {string}
 */
export const getGiftingPlanForLocation = (location: Location | null): string => {
  const countryCode = transformLocationIntoValidPlanCountryCode(location);
  return basicPlanIds[countryCode];
};

enum SubscriptionType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  PERSONAL = 'PERSONAL',
  BOOSTER = 'BOOSTER',
  MEGA = 'MEGA',
}
/**
 * Retrieve a listing of the current plans and their addons for the specified location
 * @param {Location | null} location
 */
export const getLocationSummaryCurrentPlans = (location: Location | null) => {
  const countryCode = transformLocationIntoValidPlanCountryCode(location);

  //  We need to get the planIds for personal (all flavours) / business / family
  const personalPlanIds = Object.keys(plansForLocations[countryCode]);
  const businessPlanId = businessPlanOptions[countryCode];
  const familyPlanId = familyPlanIdsForLocation[countryCode];

  const planSummaryData = {
    personal: {
      id: personalPlanIds[0],
      type: SubscriptionType.PERSONAL,
      name: `Starter`,
      requiredAddons: getRequiredAddonsForPlanId(personalPlanIds[0]),
      optionalAddons: getOptionalAddonsForPlanId(personalPlanIds[0]),
      addons: [...getRequiredAddonsForPlanId(personalPlanIds[0]), ...getOptionalAddonsForPlanId(personalPlanIds[0])],
    },
    booster: {
      id: personalPlanIds[1],
      name: `Essential`,
      type: SubscriptionType.PERSONAL,
      requiredAddons: getRequiredAddonsForPlanId(personalPlanIds[1]),
      optionalAddons: getOptionalAddonsForPlanId(personalPlanIds[1]),
      addons: [...getRequiredAddonsForPlanId(personalPlanIds[1]), ...getOptionalAddonsForPlanId(personalPlanIds[1])],
    },
    mega: {
      id: personalPlanIds[2],
      name: `Ultimate`,
      type: SubscriptionType.PERSONAL,
      requiredAddons: getRequiredAddonsForPlanId(personalPlanIds[2]),
      optionalAddons: getOptionalAddonsForPlanId(personalPlanIds[2]),
      addons: [...getRequiredAddonsForPlanId(personalPlanIds[2]), ...getOptionalAddonsForPlanId(personalPlanIds[2])],
    },
    business: {
      id: businessPlanId,
      name: `Business Plan`,
      type: SubscriptionType.BUSINESS,
      requiredAddons: getRequiredAddonsForPlanId(businessPlanId),
      optionalAddons: getOptionalAddonsForPlanId(businessPlanId),
      addons: [...getRequiredAddonsForPlanId(businessPlanId), ...getOptionalAddonsForPlanId(businessPlanId)],
    },
    family: {
      id: familyPlanId,
      type: SubscriptionType.FAMILY,
      name: `Family Plan`,
      requiredAddons: getRequiredAddonsForPlanId(familyPlanId),
      optionalAddons: getOptionalAddonsForPlanId(familyPlanId),
      addons: [...getRequiredAddonsForPlanId(familyPlanId), ...getOptionalAddonsForPlanId(familyPlanId)],
    },
  };

  //  We need to clean up some addons for Saudi Arabia and UAE
  if (countryCode === 'SA' || countryCode === 'AE') {
    //  The locations for SA and AE do not use the USReforestation project so we should remove it
    const businessAddonIndex = planSummaryData.business.addons.indexOf(USReforestationProject.id);
    planSummaryData.business.addons.splice(businessAddonIndex, 1);

    const familyAddonIndex = planSummaryData.family.addons.indexOf(USReforestationProject.id);
    planSummaryData.family.addons.splice(familyAddonIndex, 1);
  }

  return planSummaryData;
};

/**
 * Check that the planId is valid for the specified location
 * @param {string} planId
 * @param {Location | null} location
 */
export const isValidPlanForLocation = (planId: string, location: Location | null) => {
  const plansForLocation = getLocationSummaryCurrentPlans(location);

  const isPersonalMatch = plansForLocation.personal.id === planId;
  const isBoosterMatch = plansForLocation.booster.id === planId;
  const isMegaMatch = plansForLocation.mega.id === planId;
  const isBusinessMatch = plansForLocation.business.id === planId;
  const isFamilyMatch = plansForLocation.family.id === planId;

  return isPersonalMatch || isBoosterMatch || isMegaMatch || isBusinessMatch || isFamilyMatch;
};
